import { Component } from '@angular/core';
import { Language } from '@libraries/design-system';
import { FeaturesService } from '@libraries/feature-flags';
import { Store } from '@ngrx/store';
import { CloseActive, getPreferredLanguage, SwitchPreferredLanguage } from '../../state';

@Component({
  selector: 'coming-soon-success',
  templateUrl: './coming-soon-success.component.html',
  styleUrls: ['./coming-soon-success.component.scss'],
  standalone: false,
})
export class ComingSoonSuccessComponent {
  preferredLanguage$ = this.store.select(getPreferredLanguage);

  constructor(private store: Store, public features: FeaturesService) {}

  goHome() {
    if (window) window.location.href = 'https://www.ygrene.com';
  }

  toggleLanguage(language: Language) {
    this.store.dispatch(
      SwitchPreferredLanguage({
        preferredLanguage: language,
      })
    );
  }

  close() {
    this.store.dispatch(CloseActive());
  }
}
